import e from "react";
import { Card as c } from "../Card/Card.js";
import { Flex as a } from "../Flex/Flex.js";
import { cls as d } from "../../helpers/cls.js";
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const o = _ref => {
  let {
    image: r,
    title: t,
    description: m,
    variant: i = "text-down"
  } = _ref;
  return e.createElement(c, {
    className: d({
      "olx-card-cover-image": !0,
      ["olx-card-cover-image--".concat(i)]: !0
    }),
    tag: "section",
    variant: "outlined",
    "data-ds-component": "DS-CardCoverImage"
  }, e.createElement(a, {
    className: "olx-card-cover-image__primary",
    flexDirection: "column"
  }, m, t), e.createElement(a, {
    className: "olx-card-cover-image__secondary"
  }, r));
};
o.displayName = "CardCoverImage";
export { o as CardCoverImage };